/** Current roots, with legacy roots accepted during the repository transition. */
export const PROCESS_TIERS = ['1 Cœur de métier', '2 Management', '3 Support'];
const LEGACY_TIERS = ['1 Core Value-Shop Processes', '2 Management Processes', '3 Support Processes'];
const ACTIVE_ROOTS = new Set([...PROCESS_TIERS, ...LEGACY_TIERS]);

export function isProcessFile(path: string): boolean {
  return path.toLowerCase().endsWith('.bpmn') && ACTIVE_ROOTS.has(path.split('/')[0]);
}

/** Keep creation aligned with the repository being read during a rolling update. */
export function processTiers(entries: { path: string }[]): string[] {
  const roots = new Set(entries.filter(e => isProcessFile(e.path)).map(e => e.path.split('/')[0]));
  return PROCESS_TIERS.map((current, i) => roots.has(current) ? current
    : roots.has(LEGACY_TIERS[i]) ? LEGACY_TIERS[i] : current);
}
